
  import store from '@/store/index'
  import VariateConfig from '../config/VariateConfig/index.js'
  export default {
    /**
     * 功能：验证表单是否合法0~0.999
     */
     checkAge:(rule, value, callback)=>{
        if (!value && value !== 0) {
            callback(new Error('请输入数值'));
            } else {
            const num = parseFloat(value);0
            if (isNaN(num)) {
                callback(new Error('请输入有效的数字'));
            } else if (num <=0 || num>0.999) {
                callback(new Error('请输入大于0且小于0.999的数值'));
            } else {
                // 将字符串值转换为数字
                callback();
            }
        }
    },
    /**
     * 功能：验证表单最小俩位数~最大值
     */
    valueMax:(rule, value, callback)=>{
        let elFormValue=store.state.elFormValue
        if (!value && value !== 0) {
            callback(new Error('请输入数值'));
            } else {
            const num = parseFloat(value);0
            if (isNaN(num)) {
                callback(new Error('请输入有效的数字'));
            } else if (num <=elFormValue.min || num >elFormValue.max) {
                callback(new Error('请输入大于'+elFormValue.min+'且小于'+elFormValue.max+'的数值'));
            } else {
                callback();
            }
        }
    },
    /**
     * 功能：验证表单手机号
     */
    phoneNumber:(rule, value, callback)=>{
        let str = /^1\d{10}$/     //手机号正则
        if (!value && value !== 0) {
            callback(new Error('请输入手机号码'));
            } else {
            const num = parseFloat(value);0
            if (str.test(value) == false) {
                callback(new Error('请输入正确的手机号码'));
            }else {
                callback();
            }
        }
    },
    /**
     * 功能：字符串转数组判断是否有点,
     */
    stitch:(data)=>{
    var url=[];
    //过滤空字符串
        if (data === undefined || data === null || data === '') return [];
        if (data.toString().indexOf(',')==-1){url.push(data)}else{url=data.split(',')}
        return url||[];
    },
    /**
     * 功能：转换全局变量中Id为相对应的中文名称
     * @param id：要转换的全局变量id
     * @param key：要转换的全局变量key值
     * @returns {*}：id对应的name名称
     */
    formatVar: (id, key) => {
        if (id&&id.length==0) return [];
        let value=[];
        id.filter(item => {
            VariateConfig[key].filter(key =>{ 
                if(key.id == item){
                    value.push(key.name)
                }
                
            })
        })
        return value
    },
    /**
     * 功能：对字符串进行升序排序,
     */
    sortNumbersAsc(arr) {
        arr=arr.split(',')
        // 复制原数组（避免修改原数组），按数值升序排序
        return [...arr].sort((a, b) => a - b).join(',');
      },
    /**
     * 检查对象数组中，所有满足条件A的对象，其属性B是否都不为空
     * @param {Array} objArr - 对象数组
     * @param {Function} conditionA - 条件A（判断对象是否符合前提，返回布尔值）
     * @param {string} propB - 属性B的键名（需要检查是否不为空的属性）
     * @returns {boolean} 所有符合A的对象的B都不为空则返回true，否则false
     */
    allValidWhenConditionA:(objArr, conditionA, propB)=>{
        return objArr.every(obj => {
            // 若不满足条件A，则无需检查（直接视为“合格”）
            if (!conditionA(obj)) return true;
            // 若满足条件A，则必须确保属性B不为空
            const valueB = obj[propB];
            // 定义“不为空”：非null、非undefined、非空字符串（可根据需求调整）
            return valueB !== null && valueB !== undefined && valueB !== '';
        });
    },
    /**
     * 比较两个数组对象，根据关键字段匹配后赋值
     * @param {Array} arr1 - 源数组（从中获取要赋值的属性）
     * @param {Array} arr2 - 目标数组（要被赋值的数组）
     * @param {String} key - 用于匹配的关键字段（如 'id'）
     * @param {Array} props - 要从arr1复制到arr2的属性数组（如 ['name', 'status']）
     */
    matchAndAssign:(arr1, arr2, key, props)=>{
    // 遍历目标数组
    arr2.forEach(item2 => {
        // 在源数组中查找关键字段匹配的对象
        const matchedItem = arr1.find(item1 => item1[key] === item2[key]);
        
        // 如果找到匹配项，则赋值指定属性
        if (matchedItem) {
            props.forEach(prop => {
                // 只在源对象有该属性时才赋值（可选逻辑）
                if (matchedItem.hasOwnProperty(prop)) {
                item2[prop] = matchedItem[prop];
                }
            });
        }
        });
    },
      // 关键词高亮核心方法
      highlightKeyword(text, keyword) {
        if (!keyword || !text) return text;
        // 正则特殊字符转义（核心修复）
        const escapeReg = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        // 拆分字符 + 过滤空
        const charList = keyword.split('').filter(item => item.trim() !== '');
        if (charList.length === 0) return text;

        // 每个字符都转义后再拼接
        const pattern = charList.map(c => escapeReg(c)).join('|');
        const reg = new RegExp(`(${pattern})`, 'gi');

        // 高亮替换
        return text.replace(reg, '<span style="color:#0698ff;">$1</span>');
      },
}